module.exports = __webpack_public_path__ + "static/404-error-2-b47cb5390b33b1c5ef800ad43f3f1853.png";